var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center"},[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"type":"success","elevation":"2"},on:{"click":_vm.dismiss}},[_vm._v("\n  Congratulations, "+_vm._s(_vm.student_name)+"! You have graduated with "+_vm._s(_vm.class_of_degree)+"!  🎓\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }